{
  "promoter": {
    "gate": {
      "closed": {
        "title": "The program is closed for now",
        "body": "The Coreway promoter program is not open at the moment. Your account and your earnings are safe. Please check back later."
      },
      "notInvited": {
        "title": "No invitation for this account",
        "body": "You are signed in as {{email}}, but there is no promoter invitation for it. Sign out and sign in with the email your invitation was sent to."
      },
      "claim": {
        "title": "Welcome to Coreway Partners",
        "body": "We found a promoter invitation for {{email}}. Accept it to link it to this account.",
        "button": "Accept my invitation",
        "busy": "Accepting…"
      },
      "setPassword": {
        "title": "Set a password",
        "body": "Optional. With a password you can sign in without waiting for an email next time.",
        "password": "New password",
        "confirm": "Repeat the password",
        "save": "Save password",
        "saving": "Saving…",
        "skip": "Not now",
        "mismatch": "The two passwords do not match.",
        "short": "Use at least 8 characters."
      }
    }
  }
}
